import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { CircularProgress } from '@material-ui/core';
import InitialIcon from '../../Common/InitialsIcon';
import DataTable from 'react-data-table-component';
import './CaseTable.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& >  + ': {
      marginTop: theme.spacing(2),
    },
  },
  activePage: {
    color: `${theme.palette.primary.main} !important`,
    fontWeight: 'bold',
    borderBottom: '2px solid black'
  },
  openDetailsLink: {
    color: `${theme.palette.primary.main} !important`,
    fontWeight: 'bold',
    cursor: 'pointer',
    '& img': {
      marginRight: '2.25em'
    }
  },
  slider: {
    color: `${theme.palette.primary.main} !important`,
  },
}));

export default function CaseTable(props) {

  const { stateUpdate, state, openCaseDetail,homePage } = props;
  const { cases, pageLoading } = props.state;

  const classes = useStyles();

  const fetchCases = async (page) => {
    await stateUpdate({ ...state, pageNumber: page, casesPerPage: cases.casesPerPage, updateCaseTable: true });
  }

  const handlePerRowsChange = async (newPerPage, page) => {
    await stateUpdate({ ...state, pageNumber: page, casesPerPage: newPerPage, updateCaseTable: true });
  };


  const columns = [
    {
      name: <div id='client-header' name='client-header'>Client Name</div>,
      cell: (row,rowIndex) => <div id={`client-div-${rowIndex}`} name='client-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv align-items-center"><InitialIcon id={`client-image-icon-${rowIndex}`} name={row.caseIndivdualName} /><div className='mt-2' id={`client-info-${rowIndex}`} name='client-info'><span id={`client-name-${rowIndex}`} name='client-name'>{row.caseIndivdualName}</span></div></div>,
      selector: row => (row.hasOwner ? row.ownerFirstName : row.firstName),
      sortable: true,
      minWidth: '185px'
    },
    {
      name: <div id='reference-header' name='reference-header'>Reference ID</div>,
      cell: (row,rowIndex) => <div id={`reference-div-${rowIndex}`} name='reference-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv"><div id={`reference-id-${rowIndex}`} name='reference-id'>{row.referenceID}</div></div>,
      selector: row => (row.referenceID ? row.referenceID : ''),
      sortable: true,
      minWidth: '145px'
    },
    {
      name: <div id='carrier-header' name='carrier-header'>Carrier</div>,
      cell: (row,rowIndex) => <div id={`carrier-div-${rowIndex}`} name='carrier-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv"><div id={`carrier-info-${rowIndex}`} name='carrier-info'><span id={`carrier-${rowIndex}`} name='carrier' className='carrier-name'>{row.caseCarrier ? row.caseCarrier.toLowerCase() : ''}</span></div></div>,
      selector: row => (row.caseCarrier),
      sortable: true,
      maxWidth: '12%'
    },
    {
      name: <div id='product-header' name='product-header'>Product</div>,
      cell: (row,rowIndex) => <div id={`product-div-${rowIndex}`} name='product-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv">
      <div id={`product-info-${rowIndex}`} name='product-info'><span id={`case-plan-${rowIndex}`} name='case-plan'> {row.casePlan ? `${row.casePlan}` : '' }</span>
      </div></div>,
      selector: row => (row.casePlan ? row.casePlan : ''),
      sortable: true,
      minWidth: '135px'
    },
    {
      name: <div id='status-header' name='status-header'>Status</div>,
      cell: (row,rowIndex) => <div id={`status-div-${rowIndex}`} name='status-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv"><div id={`status-info-${rowIndex}`} name='status-info'><span id={`status-${rowIndex}`} name='status'>{row.caseStatus ? row.caseStatus : 'N/A'}</span></div></div>,
      selector: row => row.caseCreationDate,
      sortable: true,
      minWidth: '160px'
    },
    {
      name: <div id='financial-advisor-header' name='financial-advisor-header'>Financial Advisor</div>,
      cell: (row,rowIndex) => <div id={`financial-advisor-div-${rowIndex}`} name='financial-advisor-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv"><div id={`financial-advisor-info-${rowIndex}`} name='financial-advisor-info'><span id={`financial-advisor-${rowIndex}`} name='financial-advisor'>{row.caseAgent ? row.caseAgent : ''}</span></div></div>,
      selector: row => (row.caseAgent ? row.caseAgent : ''),
      sortable: true,
      maxWidth: '10%',
      minWidth: '170px'
    },
    {
      name:<div id='ticket-number-header' name='ticket-number-header'>Ticket Number</div>, 
      cell: (row,rowIndex) => <div id={`ticket-number-div-${rowIndex}`} name='ticket-number-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv"><div id={`ticket-number-info-${rowIndex}`} name='ticket-number-info'><span id={`ticket-number-${rowIndex}`} name='ticket-number'>{row.itsTicketNumber ? row.itsTicketNumber : ''}</span></div></div>,
      selector: row => (row.itsTicketNumber ? row.itsTicketNumber : ''),
      sortable: true,
      minWidth: '156px'
    },
    {
      name: <div id='esign-header' name='esign-header'>ESign</div>,
      cell: (row,rowIndex) => <div id={`esign-div-${rowIndex}`} name='esign-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv"><div id={`esign-info-${rowIndex}`} name='esign-info'><span id={`esign-${rowIndex}`} name='esign'>{row.isESign}</span></div></div>,
      selector: row => (row.isESign),
      sortable: true,
      maxWidth: '5%'
    },
    {
      name: <div id='replacement-header' name='replacement-header'>Replacement</div>,
      cell: (row,rowIndex) => <div id={`replacement-div-${rowIndex}`} name='replacement-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv"><div id={`replacement-info-${rowIndex}`} name='replacement-info'><span id={`replacement-${rowIndex}`} name='replacement'>{row.isReplacement ? row.isReplacement : ''}</span></div></div>,
      selector: row => (row.isReplacement  ? `Yes` : `No`),
      sortable: true,
      minWidth: '155px'
    },
    {
      name: <div id='reg-60-header' name='reg-60-header'>Reg 60</div>,
      cell: (row,rowIndex) => <div id={`reg-60-div-${rowIndex}`} name='reg-60-div' onClick={() => openCaseDetail(row.referenceID)} className="case-name pointerDiv"><div id={`reg-60-info-${rowIndex}`} name='reg-60-info'><span id={`reg-60-${rowIndex}`} name='reg-60'>{row.isReg60}</span></div></div>,
      selector: row => (row.isReg60 ? `Yes` : `No`),
      sortable: true,
      maxWidth: '6%',
      minWidth: '105px'
    },
    {
      name: '',
      cell: (row,rowIndex) => <div id={`open-case-div-${rowIndex}`} name='open-case-div' className={classes.openDetailsLink}>
        <span id={`open-case-${rowIndex}`} name='open-case' onClick={() => openCaseDetail(row.referenceID)} >OPEN</span>
      </div>,
      maxWidth: '3%'
    }
  ];

  return (
    <React.Fragment>
      <div className="caseTable activityCenterTable" id="activity-center-table">
        <DataTable
          columns={columns}
          data={cases.caseDetails}
          progressPending={pageLoading || state.casesLoading}
          progressComponent={<div className="d-flex justify-content-center p-5"><CircularProgress /></div>}
          pagination={true}
          paginationServer
          paginationPerPage={homePage ? state.casesPerPage : cases.casesPerPage}
          paginationDefaultPage={cases.pageNumber}
          paginationTotalRows={cases.totalCases}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 30]}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={fetchCases}
          persistTableHead
        />
      </div>
    </React.Fragment>
  );
}

CaseTable.propTypes = {
  state: PropTypes.shape({
    cases: PropTypes.object.isRequired
  }).isRequired,
  stateUpdate: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/CaseTable.js